import { DetailedHTMLProps, HTMLAttributes } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './lets-link-wireframing.module.css';
import bg from '../../public/letslink/idea/bg.jpg';
import {
  Container,
  Htag,
  HtagAlign,
  HtagVariant,
  Paragraph,
  SwiperScroll,
} from '../../components';

export interface LetsLinkWireframingProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export default function LetsLinkWireframing({
  className,
  ...props
}: LetsLinkWireframingProps) {
  return (
    <section className={cn(className, styles.wireframe)} {...props}>
      <Image
        alt="Linkapp background"
        src={bg}
        objectFit="contain"
        layout="fill"
        className={styles.background}
      />
      <Container variant="container_small">
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <Htag
            tag="h2"
            align={HtagAlign.center}
            variant={HtagVariant.h2}
            className={styles.wireframe_title}
          >
            wireframing
          </Htag>
        </AnimationOnScroll>
        <AnimationOnScroll
          delay={500}
          offset={100}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <Paragraph className={styles.wireframe_text}>
            During the Wireframing stage our main UX focus was put on building
            the most user friendly navigation so the users could easily switch
            between maps and Geochats, join and create their own events, see
            people nearby and get new connections.
          </Paragraph>
        </AnimationOnScroll>
      </Container>
      <AnimationOnScroll
        delay={800}
        offset={50}
        animateOnce
        duration={1.2}
        animateIn="animate__fadeIn"
      >
        <SwiperScroll />
      </AnimationOnScroll>
    </section>
  );
}
